export class FeatureImpl {
    constructor(data, _config) {
        this._config = _config;
        this._isActive = false;
        this._data = data;
        this.create();
    }
    get feature() {
        return this._feature;
    }
    set feature(value) {
        value.set('uuid', this.data.uniqueId);
        value.set('feature', this);
        this._feature = value;
    }
    get style() {
        return this._isActive ? this._activeStyle : this._style;
    }
    get layer() {
        return this._layer;
    }
    get data() {
        return this._data;
    }
    get isActive() {
        return this._isActive;
    }
    set isActive(value) {
        this._isActive = value;
        this.feature.setStyle(this.style);
    }
    get coordinates() {
        return this.feature.getGeometry().getCoordinates();
    }
    get geometry() {
        return this.feature.getGeometry();
    }
}
